<template>
	<font-awesome-icon
		class="fill-current"
		:icon="[library, icon]"
		:data-testid="`AtomFontAwesome-${library}-${icon}`"
	/>
</template>

<script lang="ts" setup>
import type { FontAwesomeIconType } from '#base/app/plugins/fontawesome';

withDefaults(defineProps<{
	icon: FontAwesomeIconType;
	library?: 'fas' | 'fab';
}>(), {
	library: 'fas',
});
</script>
